import { useEffect, useState } from "react";
import { ParentGetBehaviors } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import ParentEmpty from "./ParentEmpty";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import ParentFmt from "./ParentFmt";
import { useAuth } from "context/AuthContext";

const ParentBehaviorsTab = ({ studentId }) => {
    const { userInfo } = useAuth();
    const [data, setData] = useState(null);

    useEffect(() => {

        ParentGetBehaviors(userInfo?.token, Number(studentId)).then(r => setData(r.behaviors)).catch(() => setData([]));

    }, [studentId]);



    if (!data) return <ParentLoader />;

    if (data.length === 0) return <ParentEmpty msg="لا توجد سجلات سلوكية" />;



    const counts = {};

    data.forEach(b => {

        const type = b.behaviorType?.name || 'غير محدد';

        counts[type] = (counts[type] || 0) + 1;

    });

    const chartData = Object.keys(counts).map(key => ({ name: key, count: counts[key] }));



    return (

        <div className="space-y-6">

            {chartData.length > 0 && (

                <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl p-6 shadow-sm">

                    <h3 className="text-lg font-bold text-watomsBlue dark:text-white mb-4">📊 ملخص السلوكيات</h3>

                    <ResponsiveContainer width="100%" height={250}>

                        <BarChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>

                            <CartesianGrid strokeDasharray="3 3" stroke="currentColor" className="text-gray-200 dark:text-gray-700" vertical={false} />

                            <XAxis dataKey="name" stroke="currentColor" className="text-gray-500 dark:text-gray-400" tick={{ fontSize: 12 }} />

                            <YAxis stroke="currentColor" className="text-gray-500 dark:text-gray-400" tick={{ fontSize: 12 }} allowDecimals={false} />

                            <Tooltip contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }} cursor={{ fill: 'rgba(255,255,255,0.05)' }} />

                            <Bar dataKey="count" name="التكرار" fill="#f59e0b" radius={[4, 4, 0, 0]} maxBarSize={50} />

                        </BarChart>

                    </ResponsiveContainer>

                </div>

            )}



            <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl overflow-hidden shadow-sm">

                <div className="overflow-x-auto">

                    <table className="w-full text-base text-right">

                        <thead className="bg-gray-100/80 dark:bg-white/10 text-gray-900 dark:text-gray-100 font-bold border-b border-gray-300 dark:border-white/20">

                            <tr>

                                <th className="px-6 py-4">نوع السلوك</th>

                                <th className="px-6 py-4">التعليق</th>

                                <th className="px-6 py-4">التاريخ</th>

                            </tr>

                        </thead>

                        <tbody className="divide-y divide-gray-200 dark:divide-white/5">

                            {data.map(b => (

                                <tr key={b.id} className="hover:bg-gray-50/50 dark:hover:bg-white/5 transition-colors">

                                    <td className="px-6 py-4 whitespace-nowrap">

                                        <span className="bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-500/30 px-3 py-1 rounded-full text-sm font-bold shadow-sm">

                                            {b.behaviorType?.name || '—'}

                                        </span>

                                    </td>

                                    <td className="px-6 py-4 text-gray-800 dark:text-gray-300 font-medium min-w-[200px]">{b.comment || '—'}</td>

                                    <td className="px-6 py-4 text-gray-700 dark:text-gray-400 whitespace-nowrap font-medium">{ParentFmt(b.behavior_date || b.createdAt)}</td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    );
}

export default ParentBehaviorsTab;